export enum LocalStorageKeys {
  FYMLastScreen = 'fymCurrentScreen',
  FYMFormState = 'fymFormState',
  SYIState = 'syiState',
}
